import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { I18nProvider } from "./i18n";
import { AuthProvider, useAuth } from "./AuthContext";
import { loadProfile } from "./profileStore";

import Header from "./components/Header";
import Footer from "./components/Footer";
import Landing from "./components/Landing";
import Login from "./components/Login";
import Pricing from "./components/Pricing";
// Stripe-based PaymentSuccess removed (manual/club sales mode).
import Onboarding from "./components/Onboarding";
import Dashboard from "./components/Dashboard";
import Demo from "./components/Demo";
import About from "./components/About";
import Privacy from "./components/Privacy";
import Terms from "./components/Terms";
import AdminPanel from "./components/AdminPanel";

const ProtectedRoute = ({ children }) => {
  const { accessCode } = useAuth();
  if (!accessCode) return <Navigate to="/login" replace />;
  return children;
};

const AppRoute = () => {
  const profile = loadProfile();
  if (!profile || !profile.sport) return <Navigate to="/onboarding" replace />;
  return <Dashboard />;
};

function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <BrowserRouter>
          <div className="App grain min-h-screen flex flex-col">
            <Header />
            <main className="flex-1">
              <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/pricing" element={<Pricing />} />
                <Route path="/login" element={<Login />} />
                <Route path="/demo" element={<Demo />} />
                <Route path="/about" element={<About />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/admin" element={<AdminPanel />} />
                <Route path="/onboarding" element={<ProtectedRoute><Onboarding /></ProtectedRoute>} />
                <Route path="/app" element={<ProtectedRoute><AppRoute /></ProtectedRoute>} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </main>
            <Footer />
          </div>
        </BrowserRouter>
      </AuthProvider>
    </I18nProvider>
  );
}

export default App;
